<app-denials-multilevel-chart
  [page]="currentPage"
  [graphData]="denialsMultiLevel"
  [tabLevel]="2"
  [level]="'By Specialty'"
  [isDepartment]="false"
  [isSpecialty]="true"
  [isProvider]="false"
  [showProgressBar]="showProgressBar"
  [benchmarkType]="benchmarkType"
  [variables]="variables"
  [showVariableMenu]="true"
  [activeVarianceToggle]="activeVarianceToggle"
  [columnSelectionCallback]="whenSpecialtySelected">
</app-denials-multilevel-chart>
<app-denials-metric-data-table id="denials-data-table"
                               [showProgressBar]="showProgressBar"
                               [sortingDataAccessor]="sortingDataAccessor"
                               [rowSelectionCallback]="whenSpecialtySelected"
                               [receivedData]="denialsMultiLevel"
                               [columns]="columns"
                               [defaultSortColumn]="defaultSortColumn"
                               [shouldPutNullsAtTheBottom]="activeVarianceToggle"
                               [sortDirection]="sortDirection"
                               tableTitle="Denial Analysis By Specialty"
                               [whenSortChanged]="levelSpecificHandleSortChange"
                               [denialsTab]="true"
                               [benchmarkType]="benchmarkType"
                               [originalColumns]="originalColumns"
                               [currentPage]="currentPage"
                               [updateSortingCriteria]="updateSortingCriteria"
                               [reducerAction]="reducerAction"
                               [addRemoveOption]="true"
                               [nodePathName]="nodePathName"
></app-denials-metric-data-table>
